import React, {useContext} from "react"
import {Text, View} from "@react-pdf/renderer"
import {baseStyles} from "../styles"
import {Pill, PillDivider} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

// One-row strip directly under the topbar: vehicle title + spec on the
// left (vertical-rule separated), then a horizontal row of compact
// key-value pills (Lender · Type · MSRP · State · County).
export const VehicleInfoPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const car      = pdfData.car_detail
    const location = pdfData.location

    const titleParts = [car.year, car.make, car.model].filter(Boolean).join(' ')
    const specParts  = [
        car.style_description,
        car.trim,
        car.manufacture_code ? `[${car.manufacture_code}]` : '',
    ].filter(Boolean).join(' · ')

    const typeStr = `${pdfData.lease_type || ''}${pdfData.term ? ` · ${pdfData.term}` : ''}`
    const msrpStr = pdfData.msrp ? pdfData.msrp.toDollarFormat() : '—'

    const lenderValue = pdfData.lender_name || '—'

    return (
        <View style={baseStyles.vehicleInfoRow}>
            {/* Left: vehicle name + spec */}
            <View style={baseStyles.vehicleNameBlock}>
                <Text style={baseStyles.vehicleName}>{titleParts}</Text>
                {specParts.length > 0 && (
                    <Text style={baseStyles.vehicleSpec}>{specParts}</Text>
                )}
            </View>

            {/* Right: pill row. The Lender gets a hard maxWidth so a long
                bank name wraps to a second line rather than pushing the
                rest of the pills off-screen. */}
            <View style={baseStyles.pillContainer}>
                <Pill
                    label="Lender"
                    value={lenderValue}
                    style={{maxWidth: 120}}
                />
                <PillDivider/>
                <Pill label="Type"   value={typeStr || '—'}/>
                <PillDivider/>
                <Pill label="MSRP"   value={msrpStr}/>
                <PillDivider/>
                <Pill label="State"  value={location?.state  || '—'}/>
                <PillDivider/>
                <Pill label="County" value={location?.county || '—'}/>
            </View>
        </View>
    )
}
